import { render, staticRenderFns } from "./CreateItensNotaFiscalView.vue?vue&type=template&id=5ab02815&scoped=true"
import script from "./CreateItensNotaFiscalView.vue?vue&type=script&lang=js"
export * from "./CreateItensNotaFiscalView.vue?vue&type=script&lang=js"
import style0 from "./CreateItensNotaFiscalView.vue?vue&type=style&index=0&id=5ab02815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab02815",
  null
  
)

export default component.exports